@for (group of groups; track trackGroup($index, group)) {
    <ms-event-group [group]="group" [grouping]="grouping" [sportId]="sport.id" [hideFavourites]="hideFavourites" (toggle)="groupToggled($event.id)">
        <ndc-dynamic [ndcDynamicComponent]="leagueStatisticsComponent$ | async" [ndcDynamicInputs]="{ league: group.statistics }" />
    </ms-event-group>
}
